module.exports = __webpack_public_path__ + "static/media/img101.16b007f1.jpg";